import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import CloseIcon from '@mui/icons-material/Close';
import {
  Card,
  CardActions,
  Button,
  IconButton,
  Divider,
  Typography,
  Tooltip,
  CardContent
} from '@mui/material';
import {TFunction} from 'i18next';
import useAddToHomePromptContext from '@/shared/contexts/AddToHomePromptContext/useAddToHomePromptContext';

export default function AddToHomeItem({t}: {t: TFunction}) {
  const {
    hasFinishedInstallation,
    isReady: isPromptToInstallReady,
    promptToInstall,
    finishInstallation
  } = useAddToHomePromptContext();

  if (!isPromptToInstallReady || hasFinishedInstallation) {
    return null;
  }

  return (
    <Card
      sx={{
        width: '100%',
        bgcolor: 'transparent',
        borderColor: 'secondary.main',
        '& .MuiDivider-root': {
          bgcolor: 'secondary.main'
        }
      }}
      variant="outlined"
    >
      <CardContent sx={{pb: 0}}>
        <Typography
          sx={{
            fontWeight: 'bold'
          }}
        >
          {t('shared/common:install.title')}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {t('shared/common:install.description')}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions sx={{px: 2}}>
        <Button
          onClick={promptToInstall}
          color="secondary"
          startIcon={<AddToHomeScreenIcon />}
          variant="contained"
          disableElevation
          fullWidth
        >
          {t('shared/common:install.action')}
        </Button>
        <Tooltip title={t('shared/common:notNow') as string}>
          <IconButton size="small" aria-label="close" color="inherit" onClick={finishInstallation}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </CardActions>
    </Card>
  );
}
